import { render, staticRenderFns } from "./ReleaseApplyView.vue?vue&type=template&id=03afeaed&scoped=true&"
import script from "./ReleaseApplyView.vue?vue&type=script&lang=js&"
export * from "./ReleaseApplyView.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseApplyView.vue?vue&type=style&index=0&id=03afeaed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03afeaed",
  null
  
)

export default component.exports